// @ts-nocheck

import React from 'react'
import { RightOutlined } from '@ant-design/icons'
import Link from 'next/link'
import { WOMEN_FIND_YOUR_STYLE } from 'src/Helpers/Json/WomanCategoryList'
import Slider from 'react-slick'
import { useAppDispatch } from 'src/store/store'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import AosAnimation from 'src/utils/AosAnimation'

export default function WomenFindYourStyle() {
  const dispatch = useAppDispatch()
  const MobilefindYourStyle = {
    className: 'center',
    centerMode: false,
    infinite: false,
    slidesToShow: 5,
    speed: 500,
    rows: 2,
    slidesPerRow: 1,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  }

  return (
    <AosAnimation animationType="fade-up" duration={800}>
      <section className="section_5">
        <div className="container">
          <AosAnimation animationType="fade-up" duration={1000} delay={100}>
            <div className="section_5_head">
              <h3>Find Your Style</h3>
              <Link
                href={{
                  pathname: `/fashion/women`,
                  query: { type: 'style' },
                }}
                scroll={false}
              >
                <a>
                  See More
                  {/* <RightOutlined /> */}
                </a>
              </Link>
            </div>
          </AosAnimation>
          <div className="your_styles_block">
            {WOMEN_FIND_YOUR_STYLE.map((style, i) => {
              return (
                <React.Fragment key={i}>
                  <Link
                    href={{
                      pathname: `/fashion/women`,
                      query: { type: 'style', detail: style.name },
                    }}
                    scroll={false}
                  >
                    <div
                      className={`round img_cover_${i + 1}`}
                      onClick={() => {
                        dispatch(
                          fetchApplianceCategory({
                            modal: 'womenStyleDetails',
                            isOpen: true,
                            id: style?.name,
                          }),
                        )
                      }}
                    >
                      <div className="img_wrapper">
                        <img src={style.image} alt={`img_style${i + 1}`} />
                        {style.name && (
                          <div className="layer">
                            <span>{style.name}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </Link>
                </React.Fragment>
              )
            })}
            <div className="dots dots1"></div>
            <div className="dots dots2"></div>
            <div className="dots dots3"></div>
            <div className="dots dots4"></div>
            <div className="dots dots5"></div>
          </div>
        </div>
      </section>

      {/* MobileView section 5 */}
      <section className="mobile_view_section_5">
        <div className="section_5_heading">
          <h4>Find Your Style</h4>
          <Link
            href={{
              pathname: `/fashion/women`,
              query: { type: 'style' },
            }}
            scroll={false}
          >
            <div className="mobile_view_seeMore">
              <a>See More</a>
            </div>
          </Link>
        </div>
        <div className="mobile_view_find_your_style_section">
          <Slider {...MobilefindYourStyle}>
            {/* <div className="mobile_view_find_your_style_grid"> */}
            {WOMEN_FIND_YOUR_STYLE.map((style, i) => {
              return (
                <React.Fragment key={i}>
                  <Link
                    href={{
                      pathname: `/fashion/women`,
                      query: { type: 'style', detail: style.name },
                    }}
                    scroll={false}
                  >
                    <div
                      className="mobile_view_find_your_style_gridItem"
                      onClick={() => {
                        dispatch(
                          fetchApplianceCategory({
                            modal: 'womenStyleDetails',
                            isOpen: true,
                            id: style?.name,
                          }),
                        )
                      }}
                    >
                      <div
                        className="mobile_view_find_your_style_box_alignment"
                        style={{ backgroundColor: style.color }}
                      >
                        <div className="mobile-view_fashion-img-alignment">
                          <img src={style.image} alt="bgImg" />
                          <div className="mobile-view_fashion-option-name-alignment">
                            <h5>{style.name}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </React.Fragment>
              )
            })}
            {/* </div> */}
          </Slider>
        </div>
      </section>
    </AosAnimation>
  )
}
